import { TrackListResponse, TrackDetailResponse, TrackListParams } from '@/types/track_types';
import axiosInstance from '@/utils/axios';
import { logger } from '@/utils/logger';

export const trackApi = {
  // 트랙 목록 조회
  getTrackList: async (params: TrackListParams): Promise<TrackListResponse> => {
    try {
      const apiParams = {
        ordering: params.ordering || 'latest',
        page: params.page || 1,
        page_size: params.page_size || 9,
        ...(params.search && { search: params.search }),
        ...(params.artists && { artists: params.artists }),
        ...(params.status && { status: params.status }),
      };

      const response = await axiosInstance.get<TrackListResponse>('/tracks/', {
        params: apiParams,
      });
      return response.data;
    } catch (error) {
      logger.error('트랙 목록 조회 실패', { error, params });
      throw error;
    }
  },

  // 단일 트랙 상세 정보 조회
  getTrackDetail: async (trackId: string): Promise<TrackDetailResponse> => {
    const response = await axiosInstance.get<TrackDetailResponse>(`/tracks/${trackId}/`);
    return response.data;
  },
};
